<template>
  <Card>
    <template #content>
      <div class="flex flex-col gap-8">
        <FormGroup :label="$t('forms.asset_type.asset_type_properties_form.name')" :error-text="form.errors?.name">
          <InputText
              data-cy="asset-type-name-input-box"
              v-model="form.name"
              @change="form.validate['name']"
              @keyup="onNameChange"
          />
        </FormGroup>

        <FormGroup :label="$t('forms.asset_type.asset_type_properties_form.key')" :error-text="form.errors?.key">
          <InputText
              v-model="form.key"
              @change="form.validate('key')"
              :disabled="true"
          />
        </FormGroup>

        <FormGroup :label="$t('forms.asset_type.asset_type_properties_form.company')"
                   :error-text="form.errors?.company_id">
          <Dropdown
              data-cy="select-asset-type-company"
              v-model="form.company_id"
              :options="companiesStore.getCompanyOptions"
              option-label="name"
              option-value="id"
              :disabled="disabled"
              @change="form.validate('company_id')"
              :placeholder="$t('forms.common.public')"
              show-clear
          />
        </FormGroup>

        <FormGroup :label="$t('forms.asset_type.asset_type_properties_form.description')"
                   :error-text="form.errors?.description">
					<Textarea
              ref="description"
              v-model="form.description"
              @change="form.validate('description')"
              rows="5"
          />
        </FormGroup>
      </div>
    </template>

    <template v-if="hasOnSaveListener || hasOnDeleteListener" #footer>
      <div class="flex justify-end space-x-3">
        <Button data-cy="asset-type-delete-button" class="px-8" text severity="danger" v-if="hasOnDeleteListener" @click="$emit('on-delete', form)"
                :label="$t('forms.common.delete')"
                :disabled="form.processing"/>
        <Button data-cy="asset-type-save-button" class="px-8" v-if="hasOnSaveListener" @click="$emit('on-save', form)" :label="$t('forms.common.save')"
                :disabled="form.processing"/>
      </div>
    </template>
  </Card>
</template>

<script>
import {mapStores} from "pinia";
import FormGroup from "@/Components/FormGroup.vue";
import {useCompaniesStore} from "@/stores/companies.js";

export default {
  name: "AssetTypePropertiesForm",
  components: {FormGroup},
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapStores(useCompaniesStore),
    hasOnSaveListener() {
      return !!(this.$attrs?.onOnSave);
    },
    hasOnDeleteListener() {
      return !!(this.$attrs?.onOnDelete);
    },
  },
  methods: {
    onNameChange($event) {
      this.form.key = this.form.name?.trim().replaceAll(' ', '_').toUpperCase();
      this.form.validate('key');
    }
  },
  mounted() {
    this.companiesStore.indexCompanyOptions();
  }
}
</script>

<style scoped>

</style>
